import { httpGet } from './http';
import { transformTeam, BackendTeam, FrontendTeam } from './transform';

export type { FrontendTeam };

// 获取所有团队成员
export async function getPublicTeams(): Promise<FrontendTeam[]> {
  const response = await httpGet<BackendTeam[]>('/public/teams');
  return (response || []).map(transformTeam);
}

// 根据角色获取团队成员
export async function getTeamsByRole(role: 'executive' | 'advisory'): Promise<FrontendTeam[]> {
  const response = await httpGet<BackendTeam[]>(`/public/teams?role=${role}`);
  return (response || []).map(transformTeam);
}

// 获取团队成员详情
export async function getTeamById(id: number): Promise<FrontendTeam | null> {
  try {
    const response = await httpGet<BackendTeam>(`/public/teams/${id}`);
    return transformTeam(response);
  } catch {
    return null;
  }
}
